import React from "react";
import { Navbar } from "@/components/hx/Navbar";
import { Footer } from "@/components/hx/Footer";
import {
  HannoHero,
  HannoVision,
  HannoEcosystems,
  HannoHowItWorks,
  HannoProjects,
  HannoPulse,
  HannoImpact,
  HannoPeople,
  HannoRoadmap,
  HannoPartners,
  HannoInvestment,
  HannoAbout,
  HannoContactBanner,
} from "@/components/hanno/HannoSections";

export default function HomePage() {
  return (
    <div className="App relative bg-hx-bg text-hx-text" data-testid="page-home">
      <Navbar />
      <main>
        <HannoHero />
        <HannoVision />
        <HannoEcosystems />
        <HannoHowItWorks />
        <HannoProjects />
        <HannoPulse />
        <HannoImpact />
        <HannoPeople />
        <HannoRoadmap />
        <HannoPartners />
        <HannoInvestment />
        <HannoAbout />
        <HannoContactBanner />
      </main>
      <Footer />
    </div>
  );
}
